import axios from "axios";

//Create Agent
const createAgent = async (agent, token) => {
  const response = await axios.post("/api/v1/agent", agent, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Get All Agents
const getAllAgents = async (token) => {
  const response = await axios.get("/api/v1/agent?sort=-createdAt", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Get Agent By Id
const getAgentById = async (id, token) => {
  const response = await axios.get(`/api/v1/agent/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Update Agent
const updateAgent = async (id, agent, token) => {
  const response = await axios.patch(`/api/v1/agent/${id}`, agent, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Delete Agent
const deleteAgent = async (id, token) => {
  const response = await axios.delete(`/api/v1/agent/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

// Get Total Agents Count
// const getAgentCount = async () => {
//   const response = await axios.get("/api/v1/agent/count");
//   return response.data.count;
// };

const agentService = {
  createAgent,
  getAllAgents,
  getAgentById,
  updateAgent,
  deleteAgent,
};

export default agentService;
